import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getAdvertListFilter } from "./Services";
import { getCategoryTreeById,getCategoryById,getCategoryFilter } from '../Details/Services';
import detailsEndPoints from "apps/RealState/Details/EndPoints"


export const useGetAdverts= (filter:any) => {
  return useQuery(
    [endpoints.getAdvertList,filter],
    () => getAdvertListFilter(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

export const useGetCategoryTreeById= (categoryId:string) => {
  return useQuery(
    [detailsEndPoints.getCategoryTreeById,categoryId],
    () => getCategoryTreeById(categoryId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};
export const useGetCategoryByFilter= (categoryId:string) => {
  return useQuery(
    [detailsEndPoints.getCategoryTreeByFilter,categoryId],
    () => getCategoryFilter(categoryId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};
